import React from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import GetNewsResponse from '../../../Api/CRM/Responses/NewsResponse';
import i18n from '../../../base/i18n';
import { convertUtcToUserTimezone } from '../../../utils/helpers';
import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import ViewButton from '../../elements/ViewButton';
import Card from '../../elements/common/Card';
import TableHead from '../../elements/common/TableHead';
import TableLoader from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import { PERMISSION } from '../../helpers/Permissions';
import useAutoPaginator from '../../hooks/useAutoPaginator';

function NewsList() {
    const { items, updateItems, isLoading, auto } = useAutoPaginator<GetNewsResponse>(
        async (page, params) => (await CRMApi.get(`news?page=${page}`, { params })).data
    );

    return (
        <Card title="All News">
            <ActionButton url="/news/create" title="Create new news" permissions={[PERMISSION.CREATE_NEWS]} />
            <TableLoader isLoading={isLoading}>
                <table className="table model-list">
                    <TableHead>
                        <div />
                        <th>ID</th>
                        <th>Title</th>
                        <th>Publication date</th>
                        <th>URL</th>
                    </TableHead>
                    <tbody>
                        {items.map((news) => (
                            <tr key={news.id}>
                                <td>
                                    <ViewButton url={`/news/${news.id}`} permissions={[PERMISSION.VIEW_NEWS]} />
                                    <EditButton url={`/news/${news.id}/edit`} permissions={[PERMISSION.UPDATE_NEWS]} />
                                    <DeleteButton
                                        url={`/crea/api/news/${news.id}`}
                                        action={updateItems}
                                        permissions={[PERMISSION.DELETE_NEWS]}
                                    />
                                </td>
                                <td>{news.id}</td>
                                <td>{news.title}</td>
                                <td>{convertUtcToUserTimezone(news.publication_date)}</td>
                                <td>
                                    <a href={getNewsUrl(news)} target="_blank" rel="noreferrer">
                                        {news.slug}
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

function getNewsUrl(news: GetNewsResponse) {
    const routeName = i18n.t('routes.news', { lng: news.language.code });

    return `${window.location.protocol}//${window.location.host}/${news.language.code}/${routeName}/${news.slug}`;
}

export default NewsList;
